import type { ComponentClass } from 'react'
import { createContext, useContext } from 'react'
import { type RPPCoreContext } from './RPPCore.types'

export const CoreContext = createContext<Readonly<RPPCoreContext>>(null)

export const useCoreContext = () => useContext(CoreContext)

export const withCoreContext = <T extends ComponentClass>(OriginalComponent: T) => {
  const EnhancedComponent = (props: any) => {
    const ctx = useCoreContext()
    return <OriginalComponent {...props} coreContext={ctx} />
  }

  // Ensures the returned component has the same shape as the original,
  return EnhancedComponent as unknown as T
}
